import React from 'react';
import { SerializedStyles } from '@emotion/react';

import { Show } from '@components';
import { useContactDetails } from '@hooks';

import { CallsToActionContainer } from './styles';

interface ICallsToActionProps {
  direction?: 'vertical' | 'horizontal';
  useEmail?: boolean;
  buttonContent?: {
    phone?: React.ReactNode;
    scroll?: React.ReactNode;
    email?: React.ReactNode;
  };
  invert?: boolean;
  cssOverrides?: SerializedStyles;
}

const CallsToAction = ({
  direction = 'horizontal',
  useEmail = false,
  buttonContent,
  cssOverrides,
}: ICallsToActionProps) => {
  const { email, phone } = useContactDetails();

  // TODO: scroll to nearest contact form logic here

  const phoneHref = `tel:${phone.trim().replaceAll(' ', '')}`;
  const emailHref = `email:${email.trim()}`;

  return (
    <CallsToActionContainer
      className="calls_to_action"
      cssOverrides={cssOverrides}
    >
      <div
        className={`calls_to_action__wrap calls_to_action__wrap--${direction}`}
      >
        <a className="calls_to_action__phone" href={phoneHref}>
          {buttonContent?.phone || (
            <>
              <span className="calls_to_action__span--light">Call 24/7</span>{' '}
              {phone}
            </>
          )}
        </a>
        <Show
          when={useEmail}
          fallback={
            <a className="calls_to_action__fallback" role="button">
              {buttonContent?.scroll || `Get in touch`}
            </a>
          }
        >
          <a className="calls_to_action__email" href={emailHref}>
            {buttonContent?.email || `Email us`}
          </a>
        </Show>
      </div>
    </CallsToActionContainer>
  );
};

export type { ICallsToActionProps };
export { CallsToAction };
